import React, { useState, useEffect } from "react";
import {
  Trash2,
  Plus,
  Minus,
  RefreshCw,
  ShoppingCart,
  Tag,
  Truck,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ShippingZonesDropdown from "./ShippingZonesDropdown ";
import Alert from "../../pages/Alert";
import { usePanier } from "../homePage/PanierContext";
import { toast } from "react-toastify";
import ShippingCalculator from "./ShippingCalculator";
import PromoCodeInput from "./PromoCodeInput";
const BackendUrl = process.env.REACT_APP_Backend_Url;

const PanierPage = ({
  total,
  setTotal,
  codeP,
  setCodeP,
  onPaymentComplete,
  acces,
  panierchg,
}) => {
  const [articles, setArticles] = useState([]);
  const [codePromo, setCodePromo] = useState("");
  const [reduction, setReduction] = useState(0);
  const [promoData, setPromoData] = useState(null);
  const [estAbonne, setEstAbonne] = useState(false);
  const [message, setMessage] = useState("");
  const [regionClient, setRegionClient] = useState("Niamey");
  const [pays, setPays] = useState("Niger");
  const [rond, setRond] = useState(false);
  const [groupedArticles, setGroupedArticles] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [loding, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [zones, setZones] = useState([]);
  const [zoneId, setZoneId] = useState(null);
  const [prixliv, setPrixliv] = useState(0);
  const [poidsTotal, setPoidsTotal] = useState(0);
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [alert, setAlert] = useState({
    visible: false,
    type: "",
    message: "ds",
  });
  const navigation = useNavigate();
  const { updatePanier, panier } = usePanier();
  const handleAdd = (produit) => {
    updatePanier(produit);
  };

  const fetchZones = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BackendUrl}/api/shipping/zones`);
      if (response.data.success) {
        setZones(response.data.zones);
      } else {
        setError("Échec du chargement des zones d'expédition");
      }
    } catch (err) {
      setError(
        "Erreur lors de la récupération des zones d'expédition: " + err.message
      );
      toast.error("Impossible de charger les zones d'expédition");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchZones();
  }, []);

  // Fonction pour regrouper les articles
  const groupArticles = (articlesArray) => {
    return articlesArray.reduce((groups, article) => {
      const productId = article._id;
      if (!groups[productId]) {
        groups[productId] = {
          productId,
          name: article.name,
          imageUrl: article.imageUrl,
          shipping: article.shipping,
          variants: [],
          totalQuantity: 0,
          baseShippingFee: 0,
          weightShippingFee: 0,
        };
      }

      groups[productId].variants.push(article);
      groups[productId].totalQuantity += article.quantity;
      return groups;
    }, {});
  };

  // Calculer les frais d'expédition pour un groupe
  const calculateGroupShipping = (group, region) => {
    const shippingInfo = group.shipping;
    if (
      !shippingInfo ||
      !shippingInfo.zones ||
      shippingInfo.zones.length === 0
    ) {
      return {
        baseShippingFee: 1000,
        weightShippingFee: 0,
      };
    }

    let zoneClient = shippingInfo.zones.find(
      (zone) => zone.name.toLowerCase() === region.toLowerCase()
    );

    if (!zoneClient && shippingInfo.zones.length > 0) {
      zoneClient = shippingInfo.zones[0];
    }

    if (zoneClient) {
      const baseShippingFee = zoneClient.baseFee || 0;
      let totalWeightFee = 0;

      // Calculer les frais de poids pour chaque variante
      group.variants.forEach((variant) => {
        const weightFee = shippingInfo.weight
          ? shippingInfo.weight * (zoneClient.weightFee || 0) * variant.quantity
          : 0;
        totalWeightFee += weightFee;
      });

      return {
        baseShippingFee,
        weightShippingFee: totalWeightFee,
      };
    }

    return {
      baseShippingFee: 1000,
      weightShippingFee: 0,
    };
  };

  const showAlert = (type, message) => {
    setAlert({ visible: true, type, message });
    setTimeout(() => {
      setAlert({ visible: false, type: "", message: "" });
    }, 5000); // 3 secondes
  };
  const handleSuccess = (message) => {
    showAlert("success", message);
  };

  const handleWarning = (message) => {
    showAlert("warn", message);
  };
  // Charger les articles du localStorage au montage du composant

  useEffect(() => {
    const panierItems = JSON.parse(localStorage.getItem("panier")) || [];
    const detecterRegion = async () => {
      setLoading(true);
      try {
        // const response = await axios.get("https://ipapi.co/json/");
        const response = await axios.get(`${BackendUrl}/proxy/ip-api`);
        // const region = response.data.region || "Niamey";
        // const pays = response.data.country_name || "Niger";
        const region = response.data.regionName || "Niamey";
        const pays = response.data.country || "Niger";
        setRegionClient(region.toLowerCase());
        setPays(pays);
        setLoading(false);

        // Grouper les articles et calculer les frais d'expédition
        const grouped = groupArticles(panierItems);
        Object.keys(grouped).forEach((productId) => {
          const shippingFees = calculateGroupShipping(
            grouped[productId],
            region
          );
          grouped[productId] = {
            ...grouped[productId],
            ...shippingFees,
          };
        });

        setGroupedArticles(grouped);
        setArticles(panierItems);
        calculerTotal();
      } catch (error) {
        setLoading(false);
        console.error("Erreur de détection de région", error);
        const grouped = groupArticles(panierItems);
        setGroupedArticles(grouped);
        setArticles(panierItems);
        calculerTotal();
      }
    };

    detecterRegion();
  }, []);

  // Fonction pour gérer l'expansion/réduction des groupes
  const toggleGroupExpansion = (productId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  const supprimerArticle = (id, colors, sizes) => {
    // Filtrer pour supprimer l'article spécifique avec ses détails

    const updatedArticles = articles.filter(
      (article) =>
        !(
          article._id === id &&
          article.colors[0] === colors[0] &&
          article.sizes[0] === sizes[0]
        )
    );

    // Mettre à jour l'état et le localStorage
    setArticles(updatedArticles);
    // localStorage.setItem("panier", JSON.stringify(updatedArticles));
    handleAdd(updatedArticles);

    // Mettre à jour groupedArticles
    const newGrouped = groupArticles(updatedArticles);

    setGroupedArticles(newGrouped);
    panierchg();
    setMessage("Article supprimé avec succès !");
  };

  // const calculerSousTotal = () => {
  //   return articles.reduce(
  //     (total, article) => total + article.price * article.quantity,
  //     0
  //   );
  // };

  const handleShippingSelect = (shippingMethod) => {
    setSelectedShipping(shippingMethod);
    console.log("Méthode de livraison sélectionnée:", shippingMethod);
  };

  const ValidCode = () => {
    if (acces === "non") {
      handleWarning("Veuiller Vous connecter d'abord");
      setTimeout(() => {
        navigation("/Connexion?fromCart=true");
      }, 500);
      return;
    }
    if (codePromo.length === 0) {
      handleWarning("code invalide.");
      return;
    }
    setRond(true);
    const userId = JSON.parse(localStorage.getItem("userEcomme"))?.id;
    axios
      .get(`${BackendUrl}/getCodePromoByHashedCode`, {
        params: {
          hashedCode: codePromo,
          welcom: codePromo === "BIENVENUE20" ? true : false,
          id: userId,
        },
      })
      .then((code) => {
        setRond(false);

        if (code.data.data.isValide) {
          if (!codeP || codeP.code !== code.data.data.code) {
            const promoData = code.data.data;
            const sousTotal = calculerSousTotal();
            let reductionCalculee = 0;

            if (promoData?.type === "percentage" || promoData?.isWelcomeCode === true) {
              reductionCalculee = (sousTotal * promoData?.prixReduiction) / 100;
              if (promoData?.maxDiscount) {
                reductionCalculee = Math.min(reductionCalculee, promoData.maxDiscount);
              }
              reductionCalculee = Math.min(reductionCalculee, 2000);
            } else {
              reductionCalculee = promoData?.prixReduiction || 0;
            }

            reductionCalculee = Math.min(reductionCalculee, sousTotal);
            setReduction(Math.round(reductionCalculee * 100) / 100);

            setCodeP(code.data.data);
            // Sauvegarder le code promo dans localStorage
            localStorage.setItem("orderCodeP", JSON.stringify(code.data.data));
            setMessage("Code promo appliqué avec succès !");

            // Recalculer le total après application du code promo
            setTimeout(() => calculerTotal(), 100); // Donne le temps à setReduction de se mettre à jour
          } else {
            setMessage("Ce code promo est déjà appliqué.");
          }
        } else {
          handleWarning("Ce code a expiré.");
          setReduction(0);
          localStorage.removeItem("orderCodeP");
          calculerTotal();
        }
      })
      .catch((error) => {
        console.error(error);
        handleWarning("ce code de promo n'exite pas");
        setReduction(0);
        localStorage.removeItem("orderCodeP");
        calculerTotal();
        setRond(false);
      });
  };

  const spinnerStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid #FFF",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    animation: "spin 1s linear infinite",
    margin: "auto",
  };

  // Rendu du groupe d'articles
  // Modification du rendu du groupe d'articles pour inclure ShippingZonesDropdown
  const renderArticleGroup = (group) => {
    const isExpanded = expandedGroups[group.productId];
    const totalShippingFee = group.baseShippingFee + group.weightShippingFee;

    return (
      <div
        key={group.productId}
        className="bg-white rounded-lg shadow-sm overflow-hidden mb-4"
      >
        {/* En-tête du groupe */}

        <div
          className="p-4 border-b cursor-pointer"
          onClick={() => toggleGroupExpansion(group.productId)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img
                src={group.imageUrl}
                alt={group.name}
                className="w-16 h-16 object-cover rounded"
              />
              <div>
                <h3 className="font-medium text-lg">{group.name}</h3>
                <p className="text-sm text-gray-500">
                  {group.variants.length} variante(s)
                </p>
              </div>
            </div>
            {isExpanded ? (
              <ChevronUp className="w-6 h-6" />
            ) : (
              <ChevronDown className="w-6 h-6" />
            )}
          </div>
        </div>

        {/* Liste des variantes */}
        {isExpanded && (
          <div className="p-4 space-y-4">
            {group.variants.map((variant, index) => (
              <div
                key={`${variant._id}-${index}`}
                className="flex items-center justify-between border-b pb-4"
              >
                {/* Image de la couleur si elle existe */}
                {variant?.imageUrl && (
                  <img
                    src={variant.imageUrl}
                    alt={`Couleur ${variant.colors[0]}`}
                    className="w-12 h-12 object-cover rounded-md border"
                  />
                )}
                <div className="flex-1">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600 ml-3">
                      {variant.colors[0] && `Couleur: ${variant.colors[0]}`}
                    </span>
                    <span className="text-sm text-gray-600 ml-3">
                      {variant.sizes[0] && `Taille: ${variant.sizes[0]}`}
                      
                    </span>
                  </div>
                  {/* <div className="text-[#008751] font-medium ml-3">
                    {variant.price} F CFA
                  </div> */}

                  {(() => {
                    // Détermine le prix normal (on prend d'abord le prix de la variante si disponible)
                    const vari = variant.variants.find(
                      (item) => item.color === variant.colors[0]
                    );

                    const normalPrice =
                      vari?.price && vari.price > 0
                        ? vari?.price
                        : variant.prix || 0;

                    const discountPrice =
                      vari?.promoPrice && vari.promoPrice > 0
                        ? vari?.promoPrice
                        : variant.prixPromo || 0;

                    // Détermine le prix promo (on prend d'abord le prix promo de la variante si disponible)
                    // const discountPrice =
                    //   variant.promoPrice || variant.prixPromo || 0;

                    // Vérifie si le produit est en promotion
                    const isOnPromo =
                      (discountPrice > 0 && discountPrice < normalPrice) ||
                      variant.isOnPromo;

                    if (isOnPromo) {
                      return (
                        <>
                          <div className="line-through text-red-500 font-medium ml-3">
                            {normalPrice} €
                          </div>
                          <div className="text-[#008751] font-medium ml-3">
                            {discountPrice} €
                          </div>
                          
                        </>
                      );
                    } else {
                      return (
                        <div className="text-[#008751] font-medium ml-3">
                          {normalPrice} €
                        </div>
                      );
                    }
                  })()}

                  {variant?.shipping?.weight && variant?.quantity ? (
  <div className="inline-block px-2 py-1 border border-[#008751] text-[#008751] rounded-md text-sm font-medium hover:bg-[#008751] hover:text-white transition duration-150">
    {variant.shipping.weight} Kg × {variant.quantity}
  </div>
) : null}

                </div>
                

                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-2">
                    <button
                      className="p-1 border border-[#008751] rounded-md hover:bg-gray-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        modifierQuantite(
                          variant._id,
                          variant.colors,
                          variant.sizes,
                          -1
                        );
                      }}
                    >
                      <Minus className="h-4 w-4 text-[#008751]" />
                    </button>
                    <input
                      className="w-16 text-center border rounded-md p-1"
                      type="number"
                      min="1"
                      value={variant.quantity}
                      onChange={(e) => {
                        e.stopPropagation();
                        const newQuantity = parseInt(e.target.value) || 1;
                        modifierQuantite(
                          variant._id,
                          variant.colors,
                          variant.sizes,
                          newQuantity - variant.quantity
                        );
                        setPoidsTotal(0);
                        setPrixliv(0);
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <button
                      className="p-1 border border-[#008751] rounded-md hover:bg-gray-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        modifierQuantite(
                          variant._id,
                          variant.colors,
                          variant.sizes,
                          1
                        );
                        setPoidsTotal(0);
                        setPrixliv(0);
                      }}
                    >
                      <Plus className="h-4 w-4 text-[#008751]" />
                    </button>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      supprimerArticle(
                        variant._id,
                        variant.colors,
                        variant.sizes
                      );

                      setPoidsTotal(0);
                      setPrixliv(0);
                    }}
                    className="p-2 border border-[#008751] rounded-full hover:bg-red-50"
                  >
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Remplacer la section de rendu des articles par ceci dans le return
  const renderArticlesSection = () => {
    if (Object.keys(groupedArticles).length === 0) {
      return loding === true ? (
        <div className="flex flex-col items-center justify-center space-y-4 p-8 bg-white rounded-lg shadow-sm">
          <ShoppingCart className="h-12 w-12 text-[#008751] animate-bounce" />
          <p className="text-lg text-[#008751]">Patientez .....</p>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center space-y-4 p-8 bg-white rounded-lg shadow-sm">
          <ShoppingCart className="h-12 w-12 text-[#008751] animate-bounce" />
          <p className="text-lg text-[#008751]">Votre panier est vide</p>
        </div>
      );
    }

    return (
      <div className="space-y-4">
        {Object.values(groupedArticles).map((group) =>
          renderArticleGroup(group)
        )}
      </div>
    );
  };

  // Mettre à jour les autres fonctions existantes pour prendre en compte le groupement
  const calculerTotalFraisExpedition = () => {
    return Object.values(groupedArticles).reduce((total, group) => {
      return total + group.baseShippingFee + group.weightShippingFee;
    }, 0);
  };

  const calculerSousTotal = () => {
    return articles.reduce((total, article) => {
      // Recherche la variante correspondant à la couleur actuelle
      const vari = article.variants?.find(
        (item) => item.color === article.colors[0]
      );

      // Détermine le prix normal
      const normalPrice =
        vari?.price && vari.price > 0
          ? vari.price
          : article.prix || article.price || 0;

      // Détermine le prix promo
      const discountPrice =
        vari?.promoPrice && vari.promoPrice > 0
          ? vari.promoPrice
          : article.prixPromo || 0;

      // Vérifie si le produit est en promotion
      const isOnPromo =
        (discountPrice > 0 && discountPrice < normalPrice) ||
        vari?.isOnPromo ||
        article.isOnPromo;

      // Utiliser le prix approprié
      const prixAUtiliser = isOnPromo ? discountPrice : normalPrice;

      return total + prixAUtiliser * article.quantity;
    }, 0);
  };

  const calculerTotal = () => {
    const sousTotal = calculerSousTotal();
    const reductionAppliquee = Math.min(reduction, sousTotal);
    const totalAvecReduction = sousTotal - reductionAppliquee;
    const totalFinal = Math.round((totalAvecReduction + prixliv) * 100) / 100;
    setTotal(totalFinal);
    
    // Sauvegarder le sous-total AVANT réduction + frais de livraison sélectionnés
    const totalBeforeDiscount = sousTotal + prixliv;
    localStorage.setItem("orderTotal", totalBeforeDiscount.toString());
    localStorage.setItem("orderDiscount", reductionAppliquee.toString());
    
    return totalFinal;
  };

  // Modification de la fonction de mise à jour de la quantité
  const modifierQuantite = (id, colors, sizes, delta) => {
    setArticles((prevArticles) => {
      const updatedArticles = prevArticles.map((article) => {
        if (
          article._id === id &&
          article.colors[0] === colors[0] &&
          article.sizes[0] === sizes[0]
        ) {
          const nouvelleQuantite = Math.max(1, article.quantity + delta);
          return { ...article, quantity: nouvelleQuantite };
        }
        return article;
      });

      // Mettre à jour le localStorage
      // localStorage.setItem("panier", JSON.stringify(updatedArticles));
      handleAdd(updatedArticles);

      // Mettre à jour groupedArticles
      const newGrouped = groupArticles(updatedArticles);
      // Object.keys(newGrouped).forEach((productId) => {
      //   const shippingFees = calculateGroupShipping(
      //     newGrouped[productId],
      //     regionClient || "Niamey"
      //   );
      //   newGrouped[productId] = {
      //     ...newGrouped[productId],
      //     ...shippingFees,
      //   };
      // });
      setGroupedArticles(newGrouped);

      return updatedArticles;
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header fixe */}
      <div className="top-0 z-50 bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <h1 className="text-2xl md:text-3xl font-bold text-[#008751]">
            Votre Panier
          </h1>
        </div>
      </div>

      <div>
        {/* <ShippingCalculator
          cartWeight={11 * 1000}
          onShippingSelect={handleShippingSelect}
        /> */}

        {/* {selectedShipping && (
              <div className="next-step">
                <button onClick={() => setCurrentStep('create')}>
                  Créer le colis →
                </button>
              </div>
            )} */}
      </div>

      <div className="container mx-auto px-4 py-4">
        {message && (
          <div className="mb-4 p-3 bg-[#008751]/10 rounded-lg text-[#008751] text-sm">
            {message}
          </div>
        )}

        {articles.length === 0 ? (
          loding === true ? (
            <div className="flex flex-col items-center justify-center space-y-4 p-8 bg-white rounded-lg shadow-sm">
              <ShoppingCart className="h-12 w-12 text-[#008751] animate-bounce" />
              <p className="text-lg text-[#008751]">Patientez .....</p>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center space-y-4 p-8 bg-white rounded-lg shadow-sm">
              <ShoppingCart className="h-12 w-12 text-[#008751] animate-bounce" />
              <p className="text-lg text-[#008751]">Votre panier est vide</p>
            </div>
          )
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Liste des articles */}
            <div className="lg:col-span-2 space-y-4">
              {renderArticlesSection()}
              {/* Ajout du ShippingZonesDropdown */}
              <ShippingZonesDropdown
                zones={zones}
                zoneId={zoneId}
                setZoneId={setZoneId}
                prixliv={prixliv}
                setPrixliv={setPrixliv}
                panier={panier}
                setPoidsTotal={setPoidsTotal}
                pp={calculerSousTotal}
              />
              
            </div>

            {/* Résumé de la commande */}
            <div className="lg:sticky lg:top-20 space-y-4 h-fit">
              {/* Résumé */}
              <div className="bg-white rounded-lg shadow-sm p-4 mb-4 space-y-4">
                <h2 className="text-lg font-bold text-[#008751]">
                  Résumé de la commande
                </h2>

                <div className="space-y-2">
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Sous-total</span>
                    <span>{calculerSousTotal()} €</span>
                  </div>
                  {reduction > 0 && (
                    <div className="flex justify-between text-sm text-green-600">
                      <span>Réduction</span>
                      <span>-{Math.min(reduction, calculerSousTotal())} €</span>
                    </div>
                  )}
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Frais d'expédition total</span>
                    <span>{prixliv} €</span>
                  </div>
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Poids total</span>
                    <span>{poidsTotal} </span>
                  </div>
                  <div className="pt-2 border-t">
                    <div className="flex justify-between font-bold text-lg text-[#008751]">
                      <span>Total</span>
                      <span>{calculerTotal()} €</span>
                    </div>
                  </div>
                </div>

                {/* Code promo */}
                <div className="pt-4">
                  <h3 className="text-sm font-semibold text-[#008751] mb-2">
                    Code promo
                  </h3>
                  <PromoCodeInput
                    orderAmount={calculerSousTotal()}
                    userId={JSON.parse(localStorage.getItem("userEcomme"))?.id}
                    products={articles}
                    onPromoApplied={(data) => {
                      if (data && data.discount) {
                        setReduction(data.discount);
                        setPromoData(data);
                        setCodeP({
                          _id: data.promoCodeId,
                          code: data.code,
                          isValide: true
                        });
                        localStorage.setItem('orderCodeP', JSON.stringify({
                          _id: data.promoCodeId,
                          code: data.code,
                          discount: data.discount,
                          isValide: true
                        }));
                      } else {
                        setReduction(0);
                        setPromoData(null);
                        setCodeP(null);
                        localStorage.removeItem('orderCodeP');
                      }
                      setTimeout(() => calculerTotal(), 100);
                    }}
                  />
                </div>

                {/* Mode d'expédition */}

                {/* {renderShippingModes()} */}
                {(() => {
                  // On trouve la zone sélectionnée une seule fois au lieu de répéter la recherche
                  const selectedZone = zoneId
                    ? zones.find((item) => item._id === zoneId)
                    : null;

                  if (!selectedZone) {
                    return (
                      <div className="flex items-center justify-center p-4 bg-gray-50 rounded-md text-gray-500 border border-dashed border-gray-300">
                        <svg
                          className="w-5 h-5 mr-2 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          ></path>
                        </svg>
                        <span>Veuillez choisir une option d'expédition</span>
                      </div>
                    );
                  }

                  return (
                    <div className="p-4 border rounded-lg bg-white shadow-sm">
                      <div className="flex items-center mb-3">
                        <div className="w-3 h-3 bg-emerald-500 rounded-full mr-2"></div>
                        <h4 className="font-medium text-gray-800 text-base">
                          {selectedZone.name}
                        </h4>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                        <div className="flex flex-col bg-emerald-50 p-3 rounded-md">
                          <span className="text-xs text-gray-500 mb-1">
                            Frais de base
                          </span>
                          <span className="text-emerald-600 font-semibold">
                            {selectedZone.baseFee} €
                          </span>
                        </div>

                        <div className="flex flex-col bg-emerald-50 p-3 rounded-md">
                          <span className="text-xs text-gray-500 mb-1">
                            Frais au poids
                          </span>
                          <span className="text-emerald-600 font-semibold">
                            {selectedZone.weightFee} €
                          </span>
                        </div>

                        <div className="flex flex-col bg-emerald-50 p-3 rounded-md">
                          <span className="text-xs text-gray-500 mb-1">
                            Transport
                          </span>
                          <span className="text-emerald-600 font-semibold">
                            {selectedZone.transporteurName || "KASSARMOU"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Newsletter et réinitialisation */}
                <div className="pt-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div
                        className={`relative ${
                          estAbonne ? "bg-[#008751]" : "border"
                        } w-5 h-5 rounded flex items-center justify-center`}
                      >
                        <input
                          type="checkbox"
                          checked={estAbonne}
                          onChange={(e) => setEstAbonne(e.target.checked)}
                          className="opacity-0 absolute w-full h-full cursor-pointer"
                        />
                        {estAbonne && (
                          <span className="text-white text-xs">&#10003;</span>
                        )}
                      </div>
                      <span className="text-sm text-gray-700">
                        S'abonner à la newsletter
                      </span>
                    </div>
                    <button
                      className="p-2 hover:bg-gray-100 rounded-full"
                      onClick={() =>
                        setArticles(
                          articles.map((a) => ({ ...a, quantity: 1 }))
                        )
                      }
                    >
                      <RefreshCw className="h-4 w-4 text-[#008751]" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Bouton Commander (fixe en bas sur mobile, dans le flux sur desktop) */}
      <div className="container mx-auto px-4 py-4">
        <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white p-3 shadow-lg">
          {calculerTotal() !== 0 ? (
            <button
              onClick={() => {
                if (calculerTotal() === 0) {
                  return;
                }
                if (acces === "non") {
                  handleWarning("Veuiller Vous connecter d'abord");
                  setTimeout(() => {
                    navigation("/Connexion?fromCart=true");
                  }, 1000);
                } else if (!poidsTotal && poidsTotal <= 0) {
                  handleWarning("Veuiller choisir une option d'expedition");
                } else {
                  navigation("/OrderConfirmation?fromCart=true");
                }
              }}
              className="w-full bg-[#008751] disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-lg font-semibold hover:bg-[#008751]/90 flex items-center justify-center space-x-2"
            >
              Passer la commande {calculerTotal()} €
            </button>
          ) : (
            <></>
          )}
        </div>
        <div className="hidden lg:block">
          <div className="container mx-auto px-4 py-4">
            {calculerTotal() !== 0 ? (
              <button
                onClick={() => {
                  if (calculerTotal() === 0) {
                    return;
                  }
                  if (acces === "non") {
                    handleWarning("Veuiller Vous connecter d'abord");
                    setTimeout(() => {
                      navigation("/OrderConfirmation?fromCart=true");
                    }, 1000);
                  } else if (!poidsTotal && poidsTotal <= 0) {
                    handleWarning("Veuiller choisir une option d'expedition");
                  } else {
                    navigation("/OrderConfirmation?fromCart=true");
                  }
                }}
                // onClick={handlePayment}
                // disabled={loading || paymentStatus === "success"}
                className="w-full bg-[#008751] disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-lg font-semibold hover:bg-[#008751]/90 flex items-center justify-center space-x-2"
              >
                Passer la commande {calculerTotal()} €
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {alert.visible && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ visible: false })}
        />
      )}
    </div>
  );
};

export default PanierPage;